import type { CustomQueryOptions } from './types';

type BaseMakeQuery = {
  queryKey: string;
};

type MakeQuery<TDataType> = BaseMakeQuery & {
  queryFn: () => Promise<TDataType>;
};

type MakeQueryWithVars<TDataType, TVarsType> = BaseMakeQuery & {
  queryFn: (variables: TVarsType) => Promise<TDataType>;
};

export const makeQuery = <DataType>({
  queryFn,
  queryKey,
}: MakeQuery<DataType>) => {
  const getQueryConfig = (options?: CustomQueryOptions) => ({
    ...options,
    // Wrap queryFn to ignore React Query context object passed to queryFn
    queryFn: () => queryFn(),
    queryKey,
  });

  getQueryConfig.getQueryKey = () => queryKey;

  return getQueryConfig;
};

export const makeQueryWithVars = <DataType, VarsType>({
  queryFn,
  queryKey,
}: MakeQueryWithVars<DataType, VarsType>) => {
  const getQueryConfig = (
    variables: VarsType,
    options?: CustomQueryOptions
  ) => ({
    ...options,
    queryFn: () => queryFn(variables),
    queryKey: [queryKey, variables],
  });

  getQueryConfig.getQueryKey = (variables: VarsType) => [queryKey, variables];

  return getQueryConfig;
};
